import { render } from "./MainView.vue?vue&type=template&id=0166fab8&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=0166fab8&scoped=true&lang=css"

import exportComponent from "/Users/rose/src/golinks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0166fab8"]])

export default __exports__